// Referral attribution — first-touch, 30-day cookie (stored in localStorage).
// The visitor hitting any page with ?ref=SLUG gets that slug persisted. Later
// an explicit ?ref= on a subsequent visit overwrites the stored value
// (last-click wins ONLY when a new ref is supplied — otherwise first-touch is
// retained through the cookie lifetime).
const KEY = "pg_ref_v1"; // JSON: { slug, ts }
const LIFETIME_MS = 30 * 86400 * 1000;
const SLUG_RE = /^[A-Z0-9]{4,12}$/;

export function captureReferralFromLocation() {
  if (typeof window === "undefined") return null;
  try {
    const qs = new URLSearchParams(window.location.search);
    const raw = qs.get("ref");
    if (!raw) return readReferral();
    const slug = raw.toUpperCase().trim();
    if (!SLUG_RE.test(slug)) return readReferral();
    localStorage.setItem(KEY, JSON.stringify({ slug, ts: Date.now() }));
    return slug;
  } catch {
    return null;
  }
}

export function readReferral() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const { slug, ts } = JSON.parse(raw);
    if (!slug || !ts) return null;
    if (Date.now() - ts > LIFETIME_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return slug;
  } catch {
    return null;
  }
}

export function clearReferral() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
